import { Tabs } from '@infl-ts/ui-advocate-components';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import * as A from 'fp-ts/Array';
import { constant, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useRef } from 'react';
import { Translation, useTranslation } from 'react-i18next';
import PublicResponses from '../public-response';
import useFocusOnResponse from '../public-response/use-focus-on-response';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ViewResponsesButton = function ViewResponsesButton(_ref) {
  var scrollToResponses = _ref.scrollToResponses;
  return /*#__PURE__*/_jsxs(Button, {
    onClick: scrollToResponses,
    sx: {
      borderRadius: 50,
      mt: 3,
      position: 'relative',
      top: function top(t) {
        return t.spacing(2);
      }
    },
    variant: "contained",
    "data-element": "Button",
    "data-component": "ViewResponsesButton",
    "data-source-file": "public-responses.tsx",
    children: [/*#__PURE__*/_jsx(ArrowDownwardIcon, {
      sx: {
        mr: 1
      },
      "data-element": "ArrowDownwardIcon",
      "data-component": "ViewResponsesButton",
      "data-source-file": "public-responses.tsx"
    }), /*#__PURE__*/_jsx(Translation, {
      "data-element": "Translation",
      "data-source-file": "public-responses.tsx",
      children: function children(t) {
        return t('View responses from others');
      }
    })]
  });
};

var TabbedPublicResponses = function TabbedPublicResponses(_ref2) {
  var stages = _ref2.stages,
      profile = _ref2.profile;
  var ref = useRef(null);

  var scrollToResponses = function scrollToResponses() {
    return (ref === null || ref === void 0 ? void 0 : ref.current) && (ref === null || ref === void 0 ? void 0 : ref.current.scrollIntoView({
      behavior: 'smooth'
    }));
  };

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useFocusOnResponse = useFocusOnResponse(),
      focusedStageId = _useFocusOnResponse.focusedStageId,
      useScrollToFocused = _useFocusOnResponse.useScrollToFocused;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ViewResponsesButton, {
      scrollToResponses: scrollToResponses,
      "data-element": "ViewResponsesButton",
      "data-component": "TabbedPublicResponses",
      "data-source-file": "public-responses.tsx"
    }), /*#__PURE__*/_jsx(Box, {
      ref: ref,
      sx: {
        width: '100vw',
        py: 5,
        background: function background(t) {
          return t.palette.secondary.light;
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flexGrow: 1
      },
      "data-element": "Box",
      "data-source-file": "public-responses.tsx",
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          width: 1,
          mx: 'auto',
          maxWidth: {
            md: 820
          }
        },
        "data-element": "Box",
        "data-source-file": "public-responses.tsx",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          sx: {
            mb: 2,
            ml: 1,
            textAlign: isMobile ? 'center' : 'start'
          },
          "data-element": "Typography",
          "data-source-file": "public-responses.tsx",
          children: t('Responses from others')
        }), /*#__PURE__*/_jsx(Tabs, {
          scrollButtons: "auto",
          tabIndex: pipe(stages, A.findIndex(function (s) {
            return s.id === focusedStageId;
          }), O.getOrElse(constant(0))),
          items: pipe(stages, A.map(function (stage) {
            return {
              label: t('Stage {{stagePosition}}', {
                stagePosition: stage.position + 1
              }),
              component: /*#__PURE__*/_jsx(PublicResponses, {
                hideTotalCount: true,
                containerSx: {
                  py: 0
                },
                profile: profile,
                stage: stage,
                useScrollToFocused: useScrollToFocused
              })
            };
          })),
          "data-element": "Tabs",
          "data-source-file": "public-responses.tsx"
        })]
      })
    })]
  });
};

export default TabbedPublicResponses;